import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { defaultLocale, getDayjsLocale, getSupportedLocale, supportedLocales } from './locales';
import { parseDate } from './dates';

import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/de';
import 'dayjs/locale/nl';
import 'dayjs/locale/it';
import 'dayjs/locale/pl';
import 'dayjs/locale/tr';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import 'dayjs/locale/ko';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ja';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/vi';
import 'dayjs/locale/sv';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.updateLocale('zh-cn', { relativeTime: { future: '%s后' } });
dayjs.updateLocale('zh-tw', { relativeTime: { future: '%s後' } });

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    ns: 'global',
    lng: getSupportedLocale(navigator.languages),
    supportedLngs: supportedLocales,
    fallbackLng: defaultLocale,
    load: 'currentOnly',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
  });

// v26 uses the Formatter service for both interpolation and direct i18n.format calls.
i18n.services.formatter.add('price', ([amount, currency], lng) =>
  new Intl.NumberFormat(lng || i18n.language, { style: 'currency', currency }).format(amount),
);
i18n.services.formatter.add('number', (value, lng) => new Intl.NumberFormat(lng || i18n.language).format(value));
i18n.services.formatter.add('percentage', (value, lng) =>
  new Intl.NumberFormat(lng || i18n.language, {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(value),
);
i18n.services.formatter.add('date', ([source, formatString], lng) =>
  parseDate(source)
    .locale(getDayjsLocale(lng || i18n.language))
    .format(formatString),
);

export default i18n;
